import { Table } from "@/features/Table";
import { useBulkDeleteControls } from "@/features/Edit/useBulkDeleteControls";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { type S3TimeSerie, columns } from "./columns";
import { type FilterS3TimeSeriesSchema, FilterS3TimeSeries } from "./filter";

export const S3TimeSeriesTable = () => {
  const { selectionActions, modal } = useBulkDeleteControls<S3TimeSerie>({
    client: Clients.S3,
    table_name: Tables.S3_TIME_SERIES,
    resourceLabel: "Valorisation",
  });

  return (
    <>
      <Table<S3TimeSerie, FilterS3TimeSeriesSchema>
        label="Valorisation"
        client={Clients.S3}
        table_name={Tables.S3_TIME_SERIES}
        columns={columns}
        filter={<FilterS3TimeSeries />}
        actions={[
          {
            label: "actions.new",
            route: `${Clients.S3}/${Tables.S3_TIME_SERIES}/new`,
          },
        ]}
        enableRowSelection
        selectionActions={selectionActions}
      />
      {modal}
    </>
  );
};
